import { connect } from "react-redux";
import { PageSummary } from "senac-components";
import { commonSlice, contentSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import { Modal, ModalDispatchProps, ModalStateProps, ModalProps, ModalButtonOption } from "senac-components/dist/components/Modal";
import { alertSelectButton } from "../store/reducers/common";


const mapState = (state: RootState, props: any) => 
{
  const data = state.commonState.alert;

  const result: ModalStateProps = 
  {
    title : data?.title ?? "",
    description: data?.description ?? "",
    buttons: data?.buttons,
    show: data?.show == true
  }
  return result;
};

const mapDispatch = (dispatch: AppDispatch, props:any) => 
{
  const result: ModalDispatchProps  = 
  {
    onClick:(button:ModalButtonOption)=> dispatch(alertSelectButton(button)),
    onClose: ()=> dispatch(alertSelectButton(undefined))
  };
  return result;
};

const WModal = connect(mapState, mapDispatch)(Modal);

export { WModal };
